import React, { useState } from 'react';
import { Input } from '../../common';
import { GenderToggleSelector } from '../GenderToggleSelector';

export const CustomerRegistrationForm = ({ phone, onSubmit, isLoading, businessLogo }) => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [gender, setGender] = useState('female');

  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [birthDateError, setBirthDateError] = useState('');

  const handleSubmit = () => {
    // Clear previous errors
    setNameError('');
    setEmailError('');
    setBirthDateError('');

    // Validate name (required)
    if (!fullName.trim() || fullName.trim().length < 2) {
      setNameError('נא להזין שם מלא (לפחות 2 תווים)');
      return;
    }

    // Validate email (if provided)
    if (email.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email.trim())) {
        setEmailError('פורמט אימייל לא תקין');
        return;
      }
    }

    // Validate birth date (required)
    if (!birthDate) {
      setBirthDateError('נא להזין תאריך לידה');
      return;
    }

    const birthDateObj = new Date(birthDate);
    const today = new Date();
    if (birthDateObj > today) {
      setBirthDateError('תאריך לידה לא יכול להיות בעתיד');
      return;
    }

    // All validation passed, submit the form
    onSubmit({
      fullName: fullName.trim(),
      email: email.trim(),
      birthDate,
      gender
    });
  };

  return (
    <div className="min-h-screen bg-white relative flex items-center justify-center">
      <div className="max-w-md mx-auto w-full px-4 sm:px-6">
        <div className="bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 backdrop-blur-sm border border-white/20 rounded-3xl p-4 sm:p-8 shadow-2xl w-full min-w-0">
          <div className="text-center mb-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              כמעט סיימנו!
            </h3>
            <p className="text-gray-600">
              נראה שזו הפעם הראשונה שלך! בוא נכיר...
            </p>
          </div>

          <div className="space-y-4 w-full min-w-0">
            {/* Name Input */}
            <div className="w-full min-w-0">
              <input
                type="text"
                value={fullName}
                onChange={(e) => {
                  setFullName(e.target.value);
                  if (nameError) setNameError('');
                }}
                placeholder="שם מלא"
                className={`w-full min-w-0 px-4 py-3 bg-white/60 backdrop-blur-sm border rounded-2xl focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-transparent transition-all duration-300 text-right ${
                  nameError ? 'border-red-300 ring-2 ring-red-200' : 'border-white/30'
                }`}
                dir="rtl"
              />
              {nameError && (
                <p className="text-red-500 text-sm mt-1 text-right">{nameError}</p>
              )}
              {!fullName.trim() && !nameError && (
                <p className="text-red-400 text-xs mt-1 text-right">שדה חובה</p>
              )}
            </div>

            {/* Phone Input (disabled, pre-filled) */}
            <div className="w-full min-w-0">
              <input
                type="tel"
                value={phone}
                disabled
                className="w-full min-w-0 px-4 py-3 bg-gray-100 border border-gray-300 rounded-2xl text-right cursor-not-allowed text-gray-600"
                dir="rtl"
              />
            </div>

            {/* Email Input */}
            <Input
              label="כתובת אימייל (אופציונלי)"
              name="email"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (emailError) setEmailError('');
              }}
              placeholder="your.email@example.com"
              error={emailError}
              leftIcon="✉️"
            />

            {/* Birth Date Input */}
            <Input
              label="תאריך לידה"
              name="birth_date"
              type="date"
              value={birthDate}
              onChange={(e) => {
                setBirthDate(e.target.value);
                if (birthDateError) setBirthDateError('');
              }}
              error={birthDateError}
              leftIcon="🎂"
              max={new Date().toISOString().split('T')[0]} // Prevent future dates
              showRequiredLabel={!birthDate}
            />

            {/* Gender Toggle Selector */}
            <GenderToggleSelector
              value={gender}
              onChange={(selectedGender) => setGender(selectedGender)}
              error=""
              t={{
                gender: 'מגדר',
                female: 'נקבה',
                male: 'זכר'
              }}
            />

            <button
              onClick={handleSubmit}
              disabled={isLoading || !fullName.trim() || !birthDate}
              className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white py-3 rounded-2xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'רושם...' : 'המשך'}
            </button>
          </div>
        </div>

        {/* Business Logo - Below the card */}
        {businessLogo && (
          <div className="w-full py-6 flex justify-center">
            <img
              src={businessLogo}
              alt="Business Logo"
              className="h-16 w-auto object-contain"
            />
          </div>
        )}
      </div>
    </div>
  );
};
